import _ from "lodash";
import WebServices from "../WebServices";
import { showSnackBarMessage } from "./AppInfoActions";
import {
  PROCEDURES_SELECT_FUNCTION_AND_PROJECT,
  PROCEDURES_FETCH_SUCCESS,
  FUNCTIONS_FETCH,
  FUNCTIONS_FETCH_ERROR,
  FUNCTIONS_FETCH_SUCCESS,
  FUNCTIONS_SELECT_FUNCTION,
  PROCEDURE_ADD,
  FUNCTION_DETAILS_FETCH,
  FUNCTION_DETAILS_FETCH_ERROR,
  FUNCTION_DETAILS_FETCH_SUCCESS,
  PROCEDURE_EDIT,
  PROCEDURE_SAVE,
  PROCEDURE_SAVE_ERROR,
  PROCEDURE_SAVE_SUCCESS,
  FUNCTION_UPDATE_WORKFLOW,
  FUNCTION_UPDATE_WORKFLOW_SUCCESS,
  PROCEDURE_ADD_TO_WORKFLOW,
  PROCEDURE_ADD_TO_WORKFLOW_SUCCESS,
  PROCEDURE_ADD_TO_WORKFLOW_ERROR,
  FUNCTION_UPDATE_CATEGORIES_SUCCESS,
  FUNCTION_UPDATE_CATEGORIES,
  FUNCTION_UPDATE_CATEGORIES_ERROR,
  FUNCTION_UPDATE_NOTIFICATIONS,
  FUNCTION_UPDATE_NOTIFICATIONS_SUCCESS,
  FUNCTION_UPDATE_NOTIFICATIONS_ERROR,
  FUNCTIONS_EDIT_MANAGER_OF_FUNCTIONS,
  FUNCTIONS_UPDATE_IWPP_APPROVERS,
  FUNCTIONS_UPDATE_IWPP_APPROVERS_SUCCESS,
  FUNCTIONS_UPDATE_IWPP_APPROVERS_ERROR,
  FUNCTIONS_DELETE_IWPP_APPROVERS,
  FUNCTIONS_DELETE_IWPP_APPROVERS_SUCCESS,
  FUNCTIONS_DELETE_IWPP_APPROVERS_ERROR,
  FUNCTIONS_FETCH_IWPP_APPROVERS,
  FUNCTIONS_FETCH_IWPP_APPROVERS_SUCCESS,
  FUNCTIONS_FETCH_IWPP_APPROVERS_ERROR,
  GBUS_FETCH,
  GBUS_FETCH_SUCCESS,
  GBUS_FETCH_ERROR,
  MY_RR_DOCS_FETCH,
  MY_RR_DOCS_FETCH_SUCCESS,
  MY_RR_DOCS_FETCH_ERROR,
  MY_RR_DOCS

} from "./Types";

const selectFunction = (aFunction) => async (dispatch) => {
  if (!aFunction) return;

  if (aFunction.id === 0) {
    dispatch({ type: FUNCTIONS_EDIT_MANAGER_OF_FUNCTIONS });
    return;
  }

  dispatch({ type: FUNCTIONS_SELECT_FUNCTION, payload: aFunction });
  dispatch({
    type: PROCEDURES_SELECT_FUNCTION_AND_PROJECT,
    payload: { selectedFunction: aFunction },
  });

  let webServices = new WebServices();

  dispatch({ type: FUNCTION_DETAILS_FETCH });

  try {
    const categories = await webServices.getFunctionCategories(aFunction.id);
    const functionDetails = await webServices.getFunctionDetails(aFunction);

    dispatch({
      type: FUNCTION_DETAILS_FETCH_SUCCESS,
      payload: { ...functionDetails, categories },
    });
    dispatch({
      type: PROCEDURES_FETCH_SUCCESS,
      payload: { procedures: functionDetails.procedures },
    });
  } catch (error) {
    dispatch({ type: FUNCTION_DETAILS_FETCH_ERROR, payload: error });
  }
};

const updateWorkflow =
  (formData, completed = () => { }) =>
    (dispatch) => {
      let workflowStepsToUpdate = formData.workflowSteps.map(
        (workflowStep, stepIndex) => {
          return { ...workflowStep, stepIndex };
        }
      );

      workflowStepsToUpdate = {
        workflowSteps: workflowStepsToUpdate,
        shouldAutoApproveProcedures: formData.shouldAutoApproveProcedures,
      };
      dispatch({
        type: FUNCTION_UPDATE_WORKFLOW,
        payload: workflowStepsToUpdate,
      });

      let webServices = new WebServices();

      webServices
        .updateWorkflow({ workflowStepsToUpdate, functionId: formData.id })
        .then((workflowSteps) => {
          dispatch({
            type: FUNCTION_UPDATE_WORKFLOW_SUCCESS,
            payload: workflowSteps,
          });
          completed(true);
          dispatch(showSnackBarMessage("Workflow Updated"));
        })
        .catch((error) => {
          dispatch({ type: PROCEDURE_SAVE_ERROR, payload: error });
          completed(false);
          dispatch(
            showSnackBarMessage(
              "Error Saving Workflow " + error.response.data.errorMessage,
              null,
              6000
            )
          );
        });
    };

const fetchFunctions = () => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: FUNCTIONS_FETCH });

  webServices
    .getFunctions()
    .then((functions) => {
      dispatch({ type: FUNCTIONS_FETCH_SUCCESS, payload: functions });
      const selectedFunction = _.head(functions);
      dispatch(selectFunction(selectedFunction));

      // dispatch()
    })
    .catch((error) => {
      dispatch({ type: FUNCTIONS_FETCH_ERROR, payload: error });
    });
};

const fetchMyRRDocs = () => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: MY_RR_DOCS_FETCH });

  webServices
    .getMyRrDocs()
    .then((myRRDocs) => {
      dispatch({ type: MY_RR_DOCS, payload: myRRDocs });

      // dispatch()
    })
    .catch((error) => {
      dispatch({ type: MY_RR_DOCS_FETCH_ERROR, payload: error });
    });
};

const updateFunctionCategories =
  (categories, functionId) => async (dispatch) => {
    let webServices = new WebServices();
    dispatch({ type: FUNCTION_UPDATE_CATEGORIES });

    try {
      const updatedCategories = await webServices.updateFunctionCategories(
        categories,
        functionId
      );
      const functionDetails = await webServices.getFunctionDetails({
        id: functionId,
      });
      dispatch({
        type: FUNCTION_DETAILS_FETCH_SUCCESS,
        payload: { ...functionDetails, categories: updatedCategories },
      });
      dispatch({
        type: PROCEDURES_FETCH_SUCCESS,
        payload: { procedures: functionDetails.procedures },
      });
      dispatch(showSnackBarMessage("Categories Updated Succesfully"));
    } catch (error) {
      dispatch({ type: FUNCTION_UPDATE_CATEGORIES_ERROR, payload: error });
      dispatch(showSnackBarMessage("Error Updating Categories"));
    }
  };

const updateFunctionNotifications =
  (formData, updatedWorkflowStep = () => { }) =>
    (dispatch) => {
      let webServices = new WebServices();

      let workflowStepsToUpdate = formData.workflowSteps.map(
        (workflowStep, stepIndex) => {
          return { ...workflowStep, stepIndex };
        }
      );

      dispatch({
        type: FUNCTION_UPDATE_NOTIFICATIONS,
        payload: workflowStepsToUpdate,
      });

      webServices
        .updateFunctionNotifications({
          workflowStep: workflowStepsToUpdate,
          functionId: formData.id,
        })
        .then((functionDetails) => {
          dispatch({
            type: FUNCTION_UPDATE_NOTIFICATIONS_SUCCESS,
            payload: functionDetails,
          });
          dispatch(showSnackBarMessage("Notifications Updated"));
        })
        .catch((error) => {
          dispatch({ type: FUNCTION_UPDATE_NOTIFICATIONS_ERROR, payload: error });
          dispatch(showSnackBarMessage("Error Saving Notifications"));
        });
    };
const fetchIWPPApprovers = () => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: FUNCTIONS_FETCH_IWPP_APPROVERS });

  webServices
    .getIWPPApprovers(0)
    .then((approvers) => {
      dispatch({
        type: FUNCTIONS_FETCH_IWPP_APPROVERS_SUCCESS,
        payload: approvers,
      });
    })
    .catch((error) => {
      dispatch({ type: FUNCTIONS_FETCH_IWPP_APPROVERS_ERROR, payload: error });
    });
};

const deleteIWPPApproverStep = (id, completion = () => { }) => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: FUNCTIONS_DELETE_IWPP_APPROVERS });

  webServices
    .deleteIWPPAproverStep(id)
    .then(({ result, errorMessage }) => {
      dispatch(showSnackBarMessage("Step Deleted", errorMessage));
      completion(true);
      dispatch({
        type: FUNCTIONS_DELETE_IWPP_APPROVERS_SUCCESS,
        payload: result,
      });
    })
    .catch((error) => {
      completion(false);

      dispatch({ type: FUNCTIONS_DELETE_IWPP_APPROVERS_ERROR, payload: error });
    });
};

const updateIWPPWorkflowApprovers =
  (formValues, gbuId, completion) => (dispatch, getState) => {
    const webServices = new WebServices();

    const workflowStepsToUpdate = formValues.workflowSteps.map(
      (workflowStep) => ({
        id: workflowStep.id,
        userBun: workflowStep.primary ? workflowStep.primary.bun : workflowStep.proxy.bun,
        primary: workflowStep.primary ? true : false,
        stepLabel: workflowStep.stepLabel,
      })
    );
    dispatch({
      type: FUNCTIONS_UPDATE_IWPP_APPROVERS,
      payload: { workflowStepsToUpdate, gbuId },
    });

    webServices
      .updateIWPPAprovers(workflowStepsToUpdate, gbuId)
      .then((updatedGbuDetails) => {
        dispatch(showSnackBarMessage("Approvers Updated"));
        completion(true);
        dispatch({
          type: FUNCTIONS_UPDATE_IWPP_APPROVERS_SUCCESS,
          payload: updatedGbuDetails,
        });
      })
      .catch((error) => {
        dispatch(showSnackBarMessage("Error Updating Approvers"));
        completion(true);
        dispatch({
          type: FUNCTIONS_UPDATE_IWPP_APPROVERS_ERROR,
          payload: error,
        });
      });
  };

const fetchGBUs = () => (dispatch) => {
  let webServices = new WebServices();
  dispatch({ type: GBUS_FETCH });

  webServices
    .getGBUs()
    .then((gbus) => {
      dispatch({ type: GBUS_FETCH_SUCCESS, payload: gbus });
    })
    .catch((error) => {
      dispatch({ type: GBUS_FETCH_ERROR, payload: error });
    });
};
export {
  fetchFunctions,
  fetchMyRRDocs,
  selectFunction,
  updateWorkflow,
  updateFunctionCategories,
  updateFunctionNotifications,
  fetchIWPPApprovers,
  updateIWPPWorkflowApprovers,
  deleteIWPPApproverStep,
  fetchGBUs,
};
